import { useCallback } from "react";

import useMutationRunner from "~/hooks/useMutationRunner";
import { useRecordUserActivityMutation } from "~/services/endpoints/apiEndpoints";

export interface UseUserActivityMutationsReturn {
	recordUserActivity: () => Promise<boolean>;
}

const useUserActivityMutations = (): UseUserActivityMutationsReturn => {
	const { run } = useMutationRunner();
	const [recordUserActivityMutation] = useRecordUserActivityMutation();

	const recordUserActivity = useCallback(
		(): Promise<boolean> =>
			run(recordUserActivityMutation(), () => ({ errors: null }), "Failed to record user activity heartbeat", {
				silent: true
			}),
		[recordUserActivityMutation, run]
	);

	return { recordUserActivity };
};

export default useUserActivityMutations;
